import { render, staticRenderFns } from "./CadAtaDirex.vue?vue&type=template&id=bd7be616"
import script from "./CadAtaDirex.vue?vue&type=script&lang=js"
export * from "./CadAtaDirex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports